//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const LetterAndDocumentByID = createAsyncThunk(
  "LetterAndDocumentByID",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingLetterAndDocumentByID(""));
      const response = await UsePortalApi(
        `Patient/LetterAndDocumentByID`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
       dispatch(gettingLetterAndDocumentByIDSuccess(response)) 

      } else {
        dispatch(
          gettingLetterAndDocumentByIDFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingLetterAndDocumentByIDFailed(error));
    }
  }
);
const LetterAndDocumentByIDSlice = createSlice({
  name: "LetterAndDocumentByID",
  initialState: {
    LetterAndDocumentByIDData: null,
    isLetterAndDocumentByIDData: false,
    isLetterAndDocumentByIDError: false,
  },
  reducers: {
    gettingLetterAndDocumentByID: (state, action) => {
      state.LetterAndDocumentByIDData = null;
      state.isLetterAndDocumentByIDData = true;
      state.isLetterAndDocumentByIDError = false;
    },
    gettingLetterAndDocumentByIDSuccess: (state, action) => {
      state.LetterAndDocumentByIDData = action.payload;
      state.isLetterAndDocumentByIDData = false;
      state.isLetterAndDocumentByIDError = false;
    },
    gettingLetterAndDocumentByIDFailed: (state, action) => {
      state.LetterAndDocumentByIDData = null;
      state.isLetterAndDocumentByIDData = false;
      state.isLetterAndDocumentByIDError = true;
    },
    gettingLetterAndDocumentByIDClear: (state, action) => {
      state.LetterAndDocumentByIDData = null;
      state.isLetterAndDocumentByIDData = false;
      state.isLetterAndDocumentByIDError = false;
    },
  },
});
export const {
  gettingLetterAndDocumentByID,
  gettingLetterAndDocumentByIDSuccess,
  gettingLetterAndDocumentByIDFailed,
  gettingLetterAndDocumentByIDClear,
} = LetterAndDocumentByIDSlice.actions;
export default LetterAndDocumentByIDSlice.reducer;
